import styled from 'styled-components';

export const Container = styled.header`
  background-color: ${({ theme }) => theme.colors.background};
  position: sticky;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  padding: 10px 10px 0;
  margin-bottom: 10px;
`;

export const Content = styled.header`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-template-columns: ${({ hasSecondComponent, hasThirdComponent }) =>
    hasSecondComponent
      ? '1fr 2fr 1fr'
      : hasThirdComponent
        ? '1fr 0fr 1fr'
        : '1fr 0fr 0fr'};
  grid-template-rows: auto;
  align-items: center;
  width: 100%;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: ${({ hasSecondComponent, hasThirdComponent }) =>
      hasSecondComponent
        ? '1fr 1fr'
        : hasThirdComponent
          ? '1fr 0fr 1fr'
          : '1fr 0fr 0fr'};
    justify-content: space-between;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
`;

export const IconBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 12px;
  background: linear-gradient(135deg, #2f6fed 0%, #8f5ff0 100%);
  color: #ffffff;
  box-shadow: 0 8px 18px -8px rgba(47, 111, 237, 0.55);
`;

export const TitleTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;

  h3 {
    margin: 0;
  }
`;

export const Title = styled.h3`
  color: ${({ theme }) => theme.colors.text};
`;

export const Subtitle = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const MiddleContent = styled.div`
  justify-self: center;

  @media (max-width: 768px) {
    justify-self: flex-end;
  }
`;

export const LastContent = styled.div`
  justify-self: end;
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 768px) {
    grid-column: ${({ hasSecondComponent }) =>
      hasSecondComponent ? 'span 2' : 'span 1'};
  }
`;

export const Divider = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrayOpacity};
`;
